import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    ngon_ngu: undefined, //string, optional // Mã ngôn ngữ
    ten: undefined, //string, optional // Tên danh mục
    thu_tu: undefined, //integer, optional // Thứ tự hiện thị,
    anh_dai_dien_id: undefined,
    noi_bat: false,
    icon: undefined, // optional Icon của danh mục
    an: undefined, // optional Cho phép ẩn hay không
};

// validation form
model.validForm = {
    ngon_ngu: [ValidService.required], //string, optional // Mã ngôn ngữ
    ten: [], //string, optional // Tên danh mục
    thu_tu: [], //integer, optional // Thứ tự hiện thị    
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        Icon: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        }
    },
};

// validation các form khác
model.validFormOther = {
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["loai", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            ten: "",
            ngon_ngu: "",
            thu_tu: "",
        },
        valid: {
            ten: [],
            ngon_ngu: [],
            thu_tu: []
        },
        operator: {
            ten: ":regex_i:", //:regex:, $vn_text=Viêt nam
            ngon_ngu: ":regex_i:"

        }
    }
};

export default model;